export enum EventKey {
  ArrowDown = "ArrowDown",
  ArrowLeft = "ArrowLeft",
  ArrowRight = "ArrowRight",
  ArrowUp = "ArrowUp",
  Backspace = "Backspace",
  Delete = "Delete",
  End = "End",
  Enter = "Enter",
  Escape = "Escape",
  Home = "Home",
  PageDown = "PageDown",
  PageUp = "PageUp",
  Space = " ",
  Tab = "Tab"
}
